import React from "react";
import { Form } from "antd";
import { useSelector } from "react-redux";
import FormModal from "components/Modal/FormModal";
import ArticleForm from "./ArticleForm";

const AddArticle = () => {
  const faqProps = useSelector((state) => state.CurdR);
  const { AddEducation_Modal, Loader } = faqProps;
  const [form] = Form.useForm();

  return (
    <FormModal
      addButtonName="Add"
      modalTitle="Add Article"
      submitButtonText="Save"
      cancelButtonText="Cancel"
      apiMethod="POST"
      addApiName="addMedicalArticle"
      addApiRequest="AddRecordPagination"
      apiLoader="StartSpinner"
      ModalName="AddEducation_Modal"
      confirmLoading={Loader}
      ModalType="Hide_Modal"
      visible={AddEducation_Modal ? AddEducation_Modal : false}
      width={600}
      className="doctor-profile-modal"
      recordName="articleList"
      form={form}
    >
      <ArticleForm />
    </FormModal>
  );
};

export default AddArticle;
